/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseShopTheLookFragment} from '@amblique/contentful/app/contentful/fragments/shop-the-look/base-shop-the-look.fragment';
import {CardFragment} from '@amblique/contentful/app/contentful/fragments/card/card.fragment';
import {CarouselFragment} from '@amblique/contentful/app/contentful/fragments/carousel/carousel.fragment';
import {HotspotContentFragment} from '@amblique/contentful/app/contentful/fragments/hotspot-content/hotspot-content.fragment';

export const FullShopTheLookFragment = gql`
  ${BaseShopTheLookFragment}
  ${CardFragment}
  ${CarouselFragment}
  ${HotspotContentFragment}

  fragment FullShopTheLookFragment on ShopTheLook {
    ...BaseShopTheLookFragment

    hotspotsContentCollection {
      items {
        __typename
        ... on Card {
          ...CardFragment
        }
        ... on Carousel {
          ...CarouselFragment
        }
        ... on HotspotContent {
          ...HotspotContentFragment
        }
      }
    }
    hotspotsContentCursorCollection {
      items {
        __typename
        ... on Card {
          ...CardFragment
        }
        ... on Carousel {
          ...CarouselFragment
        }
        ... on HotspotContent {
          ...HotspotContentFragment
        }
      }
    }
    shopTheLookRichText: text {
      json
    }
  }
`;
